(() => {
  if (customElements.get('ccr-lazy-shop-follow')) return;

  class LazyShopFollow extends HTMLElement {
    connectedCallback() {
      if (this.loaded || this.observer) return;
      if (!('IntersectionObserver' in window)) {
        this.mount();
        return;
      }
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.mount();
      }, { rootMargin: '300px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
    }

    mount() {
      if (this.loaded) return;
      const template = this.querySelector('template');
      if (!template) return;
      this.loaded = true;
      this.observer?.disconnect();
      this.observer = null;
      const content = template.content.cloneNode(true);
      // The native Liquid filter supplies a module loader and an identical
      // inline import. Run only its external loader, once, from trusted markup.
      const loaders = [];
      for (const original of content.querySelectorAll('script')) {
        if (original.type === 'module' && original.src) {
          const loader = document.createElement('script');
          loader.type = 'module';
          loader.src = original.src;
          loaders.push(loader);
        }
        original.remove();
      }
      this.replaceChildren(content, ...loaders);
    }
  }

  customElements.define('ccr-lazy-shop-follow', LazyShopFollow);
})();
